/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { EndorseERC721, EndorseERC721Interface } from "../EndorseERC721";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "endorser",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "endorsee",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "endorsementTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "contributionTokenId",
        type: "uint256",
      },
    ],
    name: "Endorse",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "addAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOperater",
        type: "address",
      },
    ],
    name: "addOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getProjectAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "endorser",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "contributionTokenId",
        type: "uint256",
      },
    ],
    name: "hasEndorsedContribution",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "contributionTokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "removeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IShareableERC721",
        name: "_project_contributions",
        type: "address",
      },
    ],
    name: "setProjectAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "endorseTokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type EndorseERC721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EndorseERC721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EndorseERC721__factory extends ContractFactory {
  constructor(...args: EndorseERC721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "EndorseERC721";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<EndorseERC721> {
    return super.deploy(overrides || {}) as Promise<EndorseERC721>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): EndorseERC721 {
    return super.attach(address) as EndorseERC721;
  }
  connect(signer: Signer): EndorseERC721__factory {
    return super.connect(signer) as EndorseERC721__factory;
  }
  static readonly contractName: "EndorseERC721";
  public readonly contractName: "EndorseERC721";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EndorseERC721Interface {
    return new utils.Interface(_abi) as EndorseERC721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EndorseERC721 {
    return new Contract(address, _abi, signerOrProvider) as EndorseERC721;
  }
}
